import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import moment from 'moment';

import { getUser } from 'api/login';

/**
 * campos
 * first_name
 * last_name
 * user_name
 * email
 * date_of_birth
 * gender
 * role
 * country
 * sports
 */

const genders = {
  female: 'Femenino',
  male: 'Masculino',
};

const Profile = () => {
  const eventResolver = useCallback(async (key, _eventId) => {
    const { body } = await getUser();

    return body?.data?.user || null;
  }, []);

  const { data, status } = useQuery('get-user', eventResolver);

  return (
    <div className="rounded-lg bg-white mb-6 p-4 shadow-sm min-h-screen">
      <div className="flex flex-wrap lg:flex-row-reverse h-full">
        <div className="w-full md:w-1/3 mb-6 md:mb-0 md:pr-6 md:pt-24 md:pl-2 bg-gray-100 h-full">
          <Link
            to="/dashboard/profile/edit"
            className="block text-brandblue hover:underline focus:underline p-2 border-t"
          >
            Editar
          </Link>
        </div>
        <div className="w-full md:w-2/3 mb-6 md:mb-0 md:pr-6 md:mt-2">
          {status !== 'loading' && (
            <table className="table-auto w-full">
              <tbody>
                <tr>
                  <td className="p-2 border-b" colSpan={2}>
                    <div className="flex flex-wrap items-center py-4">
                      <div
                        className="rounded-full w-10 h-10 bg-cover border bg-gray-500 bg-no-repeat"
                        style={{ backgroundImage: `url(${data?.avatar_url})` }}
                      />{' '}
                      <div className="w-full lg:w-auto text-center md:text-left pt-3 md:pt-0 md:pl-4 text-xl text-brandblue font-semibold">
                        {data?.first_name} {data?.last_name}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="p-2 w-3/12 font-bold">Nombre de usuario</td>
                  <td className="p-2 border-l w-9/12">{data?.user_name}</td>
                </tr>
                <tr>
                  <td className="p-2 w-3/12 font-bold">Correo</td>
                  <td className="p-2 border-l w-9/12">{data?.email}</td>
                </tr>
                <tr>
                  <td className="p-2 w-3/12 font-bold">Sexo</td>
                  <td className="p-2 border-l w-9/12">{genders[data?.gender]}</td>
                </tr>
                <tr>
                  <td className="p-2 w-3/12 font-bold">Fecha de nacimiento</td>
                  <td className="p-2 border-l w-9/12">
                    {moment(data?.date_of_birth).format('DD/MM/YYYY')}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;
